import React from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'reactstrap';
import Navigation from 'components/Navigation';
import Filter from './Filter';
import Total from './Total';
import History from './History';

class Stats extends React.Component {
    static propTypes = {
        operator: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
        total: PropTypes.number.isRequired,
        historyLength: PropTypes.number.isRequired,
        history: PropTypes.arrayOf(PropTypes.shape({
            date: PropTypes.object.isRequired,
            price: PropTypes.number,
            type: PropTypes.string.isRequired,
            phone: PropTypes.string.isRequired,
            dateEnd: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        })).isRequired,
        ads: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })).isRequired,
        dateFrom: PropTypes.object.isRequired,
        dateTo: PropTypes.object.isRequired,
        adId: PropTypes.string.isRequired,
        onChangeDateFrom: PropTypes.func.isRequired,
        onChangeDateTo: PropTypes.func.isRequired,
        onChangeOperatorAd: PropTypes.func.isRequired,
        onLoadMoreContacts: PropTypes.func.isRequired,
        loading: PropTypes.bool,
    };

    render() {
        const {operator, onLogout, onOnlineChange, loading, onLoadMoreContacts, historyLength, dateFrom, dateTo, adId, total, history, ads, onChangeDateFrom, onChangeDateTo, onChangeOperatorAd} = this.props;

        return (
            <Row>
                <Col xs={12} md={4} xl={3} className="col-sidebar">
                    <Navigation user={operator} onOnlineChange={onOnlineChange} onLogout={onLogout}/>
                    <Filter loading={loading} dateFrom={dateFrom} dateTo={dateTo} adId={adId} onChangeDateFrom={onChangeDateFrom}
                            onChangeDateTo={onChangeDateTo} onChangeOperatorAd={onChangeOperatorAd} ads={ads} />
                </Col>
                <Col xs={12} md={8} xl={9} className="content">
                    <Total value={total}/>
                    <History length={historyLength} onLoadMoreContacts={onLoadMoreContacts} list={history}/>
                </Col>
            </Row>
        )
    }
}

export default Stats;


// WEBPACK FOOTER //
// ./src/containers/Stats/Stats.jsx